export default __webpack_public_path__ + "static/media/visa.42d2dcb1.svg";